import React, { useRef, useState, useEffect } from "react";
import { Button } from "primereact/button";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import "./search.scss";
import AdvanceSearchForm from "./advancesearch/advancesearchform";
import { CustomDialog } from "../../../../components/UI/dialog/custom-dialog";
import { APIEnv, APIStatus } from "../../../../interface/baseInterfaces";
import { SEARCH_API_CONSTANTS } from "../../../../constants/search.constanst";
import {  postDataWithDebounce } from "../../../../services/global.service";
import { useDetectClickOutside } from "react-detect-click-outside";
import { checkIsUserLoggedIn, createSlugByIdName, isMobile, isPremiumSearchPage, setDataOnLocalStorage } from "../../../../utils/globalUtilities";
// import useIndexedDB from "../../../../hooks/useIndexDb/useIndexDb";
import { useIndexedDB } from 'react-indexed-db-hook';
import { DBKey } from "../../../../constants/DBConfig";
import { IndexName } from "../../../../constants/constants";
import _ from 'lodash'
import useDebounce from "../../../../useDebounce";
import moment from 'moment';


const SearchProducts = ({ type }: any) => {
  const [advanceSearchVisible, setAdvanceSearchVisible] = useState<boolean>(false);
  const navigate = useNavigate();
  const location = useLocation();
  const inputRef = useRef<HTMLTextAreaElement>(null);
  const [value, setValue] = useState<string>("");
  const [frequentSearch, setFrequentSearch] = useState<string[]>([]);
  const [selectedSuggestion, setSelectedSuggestion] = useState<number>(-1);
  const [showSearchSuggestions, setShowSearchSuggestions] =
    useState<boolean>(false);
  const [searchSuggestions, setSearchSuggestions] = useState<Array<any>>([]);
  const allowedSearchTextCount: number = 3;
  const [finalValue, setFinalValue] = useState<string>("")
  const { add, getAll, deleteRecord } = useIndexedDB(DBKey.DBSearchDetail.StoreName);
  const [search, setSearch] = useState<any>([])
  const [allValues, setAllValues] = useState<any>([])
  const isFromInputRef = useRef(false);
  const pendingRequestCount = useRef(0);
const [advanceSearchData, setAdvanceSearchData] = useState<any>({
  allOfTheseText: '',
  exactphraseText: '',
  anyOfTheseText: '',
  noneOfTheseText: '',
  dateFrom: null,
  dateTo: null
});
  const currentText = useRef("");
  const allowedSearchLimitLength = 2;
  const [showSearch, setShowSearch] = useState<boolean>(false);
  const deleteFrequentSearch = (deletesearch: string) => {
    let objectWithSearchString = search.filter((obj: any) => obj.hasOwnProperty('SuggestionText') && String(obj.SuggestionText.toLowerCase()) == (deletesearch.toLowerCase()));
    deleteRecord(objectWithSearchString[0]?.id)
    getHistory('')
  }
  const [showSearchSuggestionsLoading,setShowSearchSuggestionsLoading]=useState<boolean>(false);
  const isLoggedIn = checkIsUserLoggedIn();

  useEffect(() => {
    setSelectedSuggestion(-1);
    
    if (window.location.pathname.includes('search')) {
      setShowSearch(true);
      if (type === 'HOME') {
        return;
      }
    }  else if (/^\/premium\/*$/.test(window.location.pathname)) {
      setShowSearch(false);
    }else {
      if (type === 'HOME') {
        setShowSearch(true);
      } else {
        setShowSearch(false);
        window.addEventListener("scroll", onScrollWindow);
        return () => {
          window.removeEventListener("scroll", onScrollWindow);
        };
      }
    }
  }, [location.pathname, type]);

  const onScrollWindow = () => {
    if (!window.location.pathname.includes('search')) {
      const currentScrollPos = window.pageYOffset;
      const maxScroll = 400;
      setShowSearch(currentScrollPos >= maxScroll);
    }
  };

  useEffect(() => {
    { allValues && setSearch(allValues) }
  }, [allValues])

  useEffect(() => {
    if (!isPremiumSearchPage(location.pathname)) {
      setValue("");
    }
  }, [location]);

  useEffect(() => {
    setSelectedSuggestion(-1)
    if (value === '') {
      const uniqueValuesSet = new Set<string>(search.map((obj: any) => obj.SuggestionText));
      const uniqueValuesArray = Array.from(uniqueValuesSet);
      setFrequentSearch(uniqueValuesArray.slice(-5).reverse());
      setSearchSuggestions([]);
    } else {
      const uniqueValuesSet = new Set<string>(search.map((obj: any) => obj.SuggestionText));
      const uniqueValuesArray = Array.from(uniqueValuesSet);
      const filteredFrequentSearches = uniqueValuesArray.filter(searchTerm => 
        searchTerm.toLowerCase().includes(value.toLowerCase())
      );
      setFrequentSearch(filteredFrequentSearches.slice(-5).reverse());
    }
  }, [value, search])

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setShowSearchSuggestionsLoading(true);
    if (e && e.target.value) {
      let value = e.target.value;
      setValue(value);
      isFromInputRef.current = true;
      if (inputRef.current) {
        inputRef.current.style.height = "auto"; 
        inputRef.current.style.height = `${Math.min(inputRef.current.scrollHeight, 200)}px`;
      }
    } else {
      setValue('');
    }
    if (inputRef.current) {
      inputRef.current.style.height = "auto"; // Reset height
      inputRef.current.style.height = `${Math.min(inputRef.current.scrollHeight, 200)}px`; // Max 4 lines (~100px)
    }
  };

  const scrollToSuggestion = (index: number) => {
    const suggestionList = document.getElementById('SuggestID');
    const selectedItem = document.getElementById(`li-${index}`);
    if (suggestionList && selectedItem) {
      selectedItem.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    let decisionBreak = (searchSuggestions?.length || 0) + (frequentSearch?.length || 0)
    if (e.key === "ArrowDown") {
      e.preventDefault(); 
      const newSelected = selectedSuggestion >= 0 ? Math.min(selectedSuggestion + 1, decisionBreak - 1) : 0;
      setSelectedSuggestion(newSelected);
      scrollToSuggestion(newSelected); 
    } else if (e.key === "ArrowUp") {
      e.preventDefault(); 
      if (selectedSuggestion > -1) {
        if (selectedSuggestion === 0) {
          setSelectedSuggestion(-1);
        } else {
          const newSelected = Math.max(selectedSuggestion - 1, 0);
          setSelectedSuggestion(newSelected);
          scrollToSuggestion(newSelected); 
        }
      }
    } else if (e.key === "Enter") {
      e.preventDefault();
      inputRef.current?.blur();
      if (pendingRequestCount.current === 0)
      setShowSearchSuggestionsLoading(false);
      setFinalValue(value.trim());
      if (selectedSuggestion >= 0) {
        let selectedSuggestionItem: any;
        if (searchSuggestions.length == 0) {
          selectedSuggestionItem = frequentSearch[selectedSuggestion];
          searchOnSuggestion(selectedSuggestionItem, true, 'history')
          // setValue('')
        }
        else {
          selectedSuggestionItem = searchSuggestions[selectedSuggestion];
          searchOnSuggestion(selectedSuggestionItem, true, 'suggestion')
          // setValue('')
        }
        // setValue('');
      } else {
        let searchQuery = '';
          if(selectedSuggestion >= 0){
            searchQuery= frequentSearch[selectedSuggestion];
            addDataToIndexDB(searchQuery)
            setTimeout(() => {
              navigateToSearchPage(searchQuery);
            }, 500);
              // setValue('')
          }else{
            searchQuery = value;
            if(searchQuery.trim().length > allowedSearchLimitLength){
              addDataToIndexDB(searchQuery)
              setTimeout(() => {
                navigateToSearchPage(searchQuery);
              }, 500);
              if (searchQuery !== finalValue) {
                // setValue('');
              }            }
          }
        
      }
      setShowSearchSuggestions(false);
    } else if (e.key === 'Escape') {
      setShowSearchSuggestions(false)
      inputRef.current?.blur()
    }
  };

  const addDataToIndexDB = (searchQuery:string) =>{
    let dataToPush = {
      [DBKey.DBSearchDetail.SchemaName1]: searchQuery,
    }
        add(dataToPush).then((event: any) => {
        });
  }

  const navigateToSearchPage = (search: string) => {
    
    const trimmedSearch = search.trim();
    setFinalValue(trimmedSearch);
  
  if (checkIsUserLoggedIn()) {
    // User is logged in, navigate to search page
    navigate(`/search?searchData=${encodeURIComponent(trimmedSearch)}`);
  } else {
    // User is not logged in, store the intended URL and redirect to login
    setDataOnLocalStorage("PREVIOUS_URL", `/premium/search?searchData=${encodeURIComponent(trimmedSearch)}`);
    window.open('/gp/auth/login', "_self");
  }
  }

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const newData = {
      allOfTheseText: params.get("q") || '',
      exactphraseText: params.get("epq") || '',
      anyOfTheseText: params.get("eq") || '',
      noneOfTheseText: params.get("oq") || '',
      dateFrom: params.get("fromDate") ? moment(params.get("fromDate"), 'YYYYMMDD').toDate() : null,
      dateTo: params.get("toDate") ? moment(params.get("toDate"), 'YYYYMMDD').toDate() : null
    };
  
    setAdvanceSearchData(newData);
    const query = params.get("searchData");
    if (query) {
      setFrequentSearch([]);
      setValue(query);
    } else if (params.get("q") || params.get("epq") || params.get("oq") || params.get("eq")) {
      setFrequentSearch([]);
      let searchString = '';
      if (params.get("q")) {
        searchString = searchString + ' ' + params.get("q");
      }
      if (params.get("epq")) {
        searchString = searchString + ' ' + JSON.stringify(params.get("epq"));
      }
      if (params.get("eq")) {
        // searchString = searchString + ' ' + params.get("eq");
        searchString = searchString + ' ' + params?.get("eq")?.split(' ').join(' OR ');
      }
      if (params.get("oq")) {
        searchString = searchString + ' -' + params.get("oq");
      }
      setValue(searchString);
    } else {
      setValue('');
      getHistory('')
    }
  }, [location.search]);

  useEffect(() => {
    inputRef.current?.blur()
    if (value) {
      setShowSearchSuggestions(false);
    }
  }, [finalValue])

  useDebounce(
    () => {
      if (value?.trim().length >= 3 && isFromInputRef.current) {
        searchSuggest(value);
      }
      isFromInputRef.current = false;
    },
    [value],
    400
);

  const searchSuggest = async (value: string) => {
    let onRequest = window.location.href;
    if (value) {
      getHistory(value)
    }
    if (value && value.length >= allowedSearchTextCount) {
      pendingRequestCount.current += 1;
      currentText.current = value;
      postDataWithDebounce(SEARCH_API_CONSTANTS.PRODUCT_SEARCH_SUGGESTION, { searchText: value }, APIEnv.NODE_PREMIUM, 'post', {}, 200).then((response: any) => {
        pendingRequestCount.current -= 1;
        if (pendingRequestCount.current === 0)
        setShowSearchSuggestionsLoading(false);
        if (response?.ResponseType === APIStatus.SUCCESS) {
          if (onRequest != window.location.href|| finalValue === value || inputRef?.current?.value!= value){
            return;
          }      
          if (response?.data?.date?.suggestions?.length) {
            if (currentText.current === value) {
              setSearchSuggestions(response?.data?.date?.suggestions);
              setShowSearchSuggestions(true)
            } 
          } else {
            setSearchSuggestions([]);
          }
          onFocusSearch(false)
        }
      }).catch((err) => {
        pendingRequestCount.current -= 1;
        if (pendingRequestCount.current === 0)
        setShowSearchSuggestionsLoading(false);
        console.error(` error: ${err.message}`);
      });
    } else {
      setSearchSuggestions([]);
    }
  }

  const selectText = () => {
    if (value != '') {
      inputRef.current?.focus()
      inputRef.current?.select()
    }
  }

  const onFocusSearch = (shouldSelectText: boolean) => {    
    getHistory("")
    if (shouldSelectText) {
      selectText()
    }
    setShowSearchSuggestions(true);
    if (inputRef.current) {
      inputRef.current.style.height = "auto";
      inputRef.current.style.height = `${Math.min(
        inputRef.current.scrollHeight,
        200
      )}px`; 
    }
  }

  const clickOutsideHandler = () => {
    setShowSearchSuggestions(false);
    setSelectedSuggestion(-1);
  }

  const ref = useDetectClickOutside({
    onTriggered: clickOutsideHandler
  });

  function searchOnSuggestion(search: any, quryFlag: boolean, type: string) {
    setShowSearchSuggestions(false);
    inputRef.current?.blur()
    if (quryFlag) {
      if (search.url && search.Index == IndexName.learning) {
        let url = window.location.origin + '/';
        url = url + 'learning' + '/' + search.id + '-' + createSlugByIdName(search.text);
        window.open(url, '_blank');
      } else {
        if (type == 'history') {
          setTimeout(() => {
            navigateToSearchPage(search);
          }, 500);
        } else {
          setTimeout(() => {
            navigateToSearchPage(search.text);
          }, 500);
        }
      }
    }
  }

  const getHistory = (searchstring: string) => {
    getAll().then(
      (response: any) => {
        getMatchedResult(response, searchstring);
      },
      (error: any) => {
        console.log(error);
      },
    );
  }

  useEffect(() => {
    if (allValues) {
      if (allValues?.length > 0) {
        const uniqueValuesSet = new Set<string>(allValues.map((obj: any) => obj.SuggestionText));
        const uniqueValuesArray = Array.from(uniqueValuesSet);
        setFrequentSearch(uniqueValuesArray.slice(0, 5))
        // setSearchSuggestions([])
      }
      else if (allValues.length == 0) {
        // setShowSearchSuggestions(false)
      }
    }

  }, [allValues])

  const getMatchedResult = (result: any, search: string) => {
    if (search.length == 0) {
      let suggestions = result;
      suggestions.reverse();
      setAllValues(suggestions);
    } else {
      let response: any = [];
      result.forEach((res: any) => {
        let strArr = search;
        let flag = res[DBKey.DBSearchDetail.SchemaName1].toLowerCase().includes(strArr.toLowerCase());
        if (flag) {
          response.push(res)
        }
      })
      let suggestions = response;
      suggestions.reverse();
      setAllValues(suggestions);
    }
  }

  const onClickReset = () => {
    setAdvanceSearchData({
      "allOfTheseText": '',
      "exactphraseText":'',
      "anyOfTheseText":'',
      "noneOfTheseText":''
    });
    // navigateToHomePage();
  }

  const onClickSearch = (advanceSearchData: any) => {
    if (isLoggedIn&&(!advanceSearchData || Object.keys(advanceSearchData).length === 0)) {
      setAdvanceSearchVisible(false);
      return;
    }
    let params: any = {};
    if (advanceSearchData) {
      if (advanceSearchData.exactphraseText) {
        params['epq'] = advanceSearchData.exactphraseText.trim();
      }
      if (advanceSearchData.anyOfTheseText) {
        params['eq'] = advanceSearchData.anyOfTheseText;
      }
      if (advanceSearchData.noneOfTheseText) {
        params['oq'] = advanceSearchData.noneOfTheseText;
      }
      if (advanceSearchData.allOfTheseText) {
        params['q'] = advanceSearchData.allOfTheseText;
      }
      if (advanceSearchData.dateFrom) {
        params['fromDate'] = moment(advanceSearchData.dateFrom).format('YYYYMMDD');
      }
      
      if (advanceSearchData.dateTo) {
        params['toDate'] = moment(advanceSearchData.dateTo).format('YYYYMMDD');
      }
    }
  
    const searchQuery = createSearchParams(params).toString();
    // addDataToIndexDB(searchQuery);
  
    if (!isLoggedIn) {
      setDataOnLocalStorage("PREVIOUS_URL", `/premium/search?${searchQuery}`);
      window.open('/gp/auth/login', "_self");
      return;
    }
  
    setAdvanceSearchData(advanceSearchData);
    setAdvanceSearchVisible(false);
  
    const path = {
      pathname: '/search',
      search: searchQuery
    };
    navigate(path);
  };
  

 const navigateToHomePage = () => {
      navigate('/');
  
  }
  const onClickCrossSearch = () => {
    setValue('');
  };
  const onSubmitSearch = (value: string) => {
    if(value.trim().length > allowedSearchLimitLength){
      addDataToIndexDB(value);
      setTimeout(() => {
        navigateToSearchPage(value);
      }, 500);
    }
  }

  const onBlurSearch = () => {
    if (inputRef.current) {
      inputRef.current.scrollTop = 0;
    }
  };
  const containerRef = useRef<HTMLDivElement>(null);
  const handleClickOutside = (event: MouseEvent) => {
    if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
      setShowSearchSuggestions(false);
      setSelectedSuggestion(-1);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const [placeholderText, setPlaceholderText] = useState("");
  useEffect(() => {
    setPlaceholderText(
      isMobile()
        ? "Search case laws, statutes, r..."
        : "Search case laws, statutes, ready referencers, expert opinions, videos & more..."
    );
  }, []);

  return (
    <>
       {((type === 'HOME' && !window.location.pathname.includes('search')) || 
        (type !== 'HOME' && showSearch)) && (
        type == 'HOME' ?
          <form
            onSubmit={(e) => {
              e.preventDefault();
              onSubmitSearch(value);   
            }}
            ref={ref}
          >
            <div className="search-sugestion-ui1 SearchInputContainer" ref={containerRef}>
              <div className="InputContainer">
                <span className="search-textarea-box"> 
                <textarea
                  ref={inputRef}
                  value={value}
                  name="text" 
                  className="input search-textarea-ui" 
                  id="input" 
                  // placeholder="Find articles, webinars, events, or research materials..."
                  placeholder={placeholderText}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown}
                  onFocus={() => onFocusSearch(true)}
                  onBlur={onBlurSearch}
                  rows={1}
                  style={{
                    height: "36px",             
                    overflowX: "hidden",         
                    overflowY: "hidden",        
                    whiteSpace: "nowrap"      
                  }}
                />
                </span>
                <span className="advance_ui_1" onClick={() => { setAdvanceSearchVisible(true) }}>
                    <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.56071 4.16855H20.4856C20.8313 4.16855 21.1244 3.87543 21.1244 3.52972C21.1244 3.184 20.8313 2.89088 20.4856 2.89088H7.56071C7.21499 2.89088 6.92188 3.184 6.92188 3.52972C6.92188 3.87543 7.21499 4.16855 7.56071 4.16855Z" fill="#969BAC" stroke="#969BAC" stroke-width="0.25" />
                      <path d="M1.51383 4.16855H3.52964C3.92117 4.16855 4.16848 3.86898 4.16848 3.52972C4.16848 3.184 3.87536 2.89088 3.52964 2.89088H1.51383C1.16812 2.89088 0.875 3.184 0.875 3.52972C0.875 3.87543 1.16812 4.16855 1.51383 4.16855Z" fill="#969BAC" stroke="#969BAC" stroke-width="0.25" />
                      <path d="M17.0881 9.03006H20.4873C20.833 9.03006 21.1261 8.73694 21.1261 8.39123C21.1261 8.04551 20.833 7.7524 20.4873 7.7524H17.0881C16.7423 7.7524 16.4492 8.04551 16.4492 8.39123C16.4492 8.73695 16.7423 9.03006 17.0881 9.03006Z" fill="#969BAC" stroke="#969BAC" stroke-width="0.25" />
                      <path d="M1.51383 9.03006H13.0553C13.4011 9.03006 13.6942 8.73694 13.6942 8.39123C13.6942 8.04551 13.4011 7.7524 13.0553 7.7524H1.51383C1.16812 7.7524 0.875 8.04551 0.875 8.39123C0.875 8.73694 1.16812 9.03006 1.51383 9.03006Z" fill="#969BAC" stroke="#969BAC" stroke-width="0.25" />
                      <path d="M7.56071 13.9315H20.4856C20.8313 13.9315 21.1244 13.6384 21.1244 13.2927C21.1244 12.947 20.8313 12.6539 20.4856 12.6539H7.56071C7.21499 12.6539 6.92188 12.947 6.92188 13.2927C6.92188 13.6384 7.21499 13.9315 7.56071 13.9315Z" fill="#969BAC" stroke="#969BAC" stroke-width="0.25" />
                      <path d="M1.51383 13.9311H3.52964C3.90925 13.9311 4.21357 13.6408 4.16843 13.2449C4.16403 12.9026 3.87274 12.6139 3.52964 12.6139H1.51383C1.16215 12.6139 0.875 12.9131 0.875 13.2923C0.875 13.638 1.16812 13.9311 1.51383 13.9311Z" fill="#969BAC" stroke="#969BAC" stroke-width="0.25" />
                      <path d="M2.89062 3.5296C2.89062 4.98203 4.09283 6.18424 5.54527 6.18424C7.0385 6.18424 8.19991 4.98076 8.19991 3.5296C8.19991 2.07716 6.9977 0.874954 5.54527 0.874954C4.09283 0.874954 2.89062 2.07716 2.89062 3.5296ZM4.16829 3.5296C4.16829 2.7686 4.78427 2.15262 5.54527 2.15262C6.30627 2.15262 6.92225 2.7686 6.92225 3.5296C6.92225 4.2906 6.30627 4.90658 5.54527 4.90658C4.78427 4.90658 4.16829 4.2906 4.16829 3.5296Z" fill="#969BAC" stroke="#969BAC" stroke-width="0.25" />
                      <path d="M12.418 8.39132C12.418 9.84376 13.6202 11.046 15.0726 11.046C16.5658 11.046 17.7273 9.84248 17.7273 8.39132C17.7273 6.93889 16.525 5.73668 15.0726 5.73668C13.6202 5.73668 12.418 6.93889 12.418 8.39132ZM13.6956 8.39132C13.6956 7.63032 14.3116 7.01435 15.0726 7.01435C15.8336 7.01435 16.4496 7.63032 16.4496 8.39132C16.4496 9.15233 15.8336 9.7683 15.0726 9.7683C14.3116 9.7683 13.6956 9.15233 13.6956 8.39132Z" fill="#969BAC" stroke="#969BAC" stroke-width="0.25" />
                      <path d="M2.89062 13.2923C2.89062 14.7448 4.09283 15.947 5.54527 15.947L8.07491 13.2923H8.19991C8.19991 13.2917 8.19991 13.2912 8.19991 13.2906C8.19893 11.8389 6.99711 10.6377 5.54527 10.6377C4.09411 10.6377 2.89062 11.7991 2.89062 13.2923ZM4.16829 13.2923C4.16829 12.5313 4.78427 11.9154 5.54527 11.9154C6.30627 11.9154 6.92225 12.5313 6.92225 13.2923C6.92225 14.0533 6.30627 14.6693 5.54527 14.6693C4.78427 14.6693 4.16829 14.0533 4.16829 13.2923Z" fill="#969BAC" stroke="#969BAC" stroke-width="0.25" />
                    </svg>
                  </span>
                <button className="search_btn"><svg width="15" height="15" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22.9012 12.3105C22.9012 18.1415 18.1678 22.8711 12.3256 22.8711C6.48336 22.8711 1.75 18.1415 1.75 12.3105C1.75 6.47962 6.48336 1.75 12.3256 1.75C18.1678 1.75 22.9012 6.47962 22.9012 12.3105Z" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M20.6775 20.6522L23.8926 23.8634L25.5001 25.469" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                  &nbsp; Search</button>

              </div>
              {((frequentSearch.length > 0 || searchSuggestions.length > 0) && showSearchSuggestions) && (
                <div className="search-sugestion active">
                  <ul className="overflow-auto max-suggestion" id="SuggestID">
                    {frequentSearch?.map((search: string, index: number) => (
                      <li key={`FrequnetSearch${index}`} id={`li-${index}`} className={`filter-select-list filter-select-history link-flex-1 link-flex-between ${index === selectedSuggestion ? 'tw-bg-slate-100' : ''}`}>
                        <span onClick={() => {
                          searchOnSuggestion(search, true, 'history')
                        }} >  <i className="pi pi-history"></i><a
                          className="search-history-link cursor-pointer"> {search} </a>

                        </span>
                        <span onClick={() => {
                          deleteFrequentSearch(search)
                        }}>
                          <a className="s-history-cross cursor-pointer">
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99284 0.333654C3.32617 0.333654 0.326172 3.33366 0.326172 7.00032C0.326172 10.667 3.32617 13.667 6.99284 13.667C10.6595 13.667 13.6595 10.667 13.6595 7.00032C13.6595 3.33366 10.6595 0.333654 6.99284 0.333654ZM10.3417 9.39933L9.40834 10.3327L7.00833 7.93266L4.60833 10.3327L3.675 9.39933L6.075 6.99933L3.675 4.59932L4.60833 3.66599L7.00833 6.06599L9.40834 3.66599L10.3417 4.59932L7.94167 6.99933L10.3417 9.39933Z" fill="#111C42" fill-opacity="0.45" />
                            </svg>
                          </a></span>
                      </li>))}
                    {
                      value?.length ?
                        <li className="suggestion-search-r1 filter-select-list link-flex-1"> <span className="pi pi-search"></span> <span>  Search:  <strong> {value} </strong> </span> </li>
                        : ''
                    }
                    {showSearchSuggestionsLoading&&value?.length>2&&<div style={{display:'flex',justifyContent:'center'}}><i className="pi pi-spinner pi-spin" style={{ fontSize: '2rem' }}></i></div> }
                    {



                    !showSearchSuggestionsLoading && searchSuggestions?.map((suggestion: any, index: number) => {
                        return <li key={`SearchSuggestion${index}`} id={`li-${index}`} className={`filter-select-list link-flex-1 ${index + frequentSearch.length === selectedSuggestion ? 'tw-bg-slate-100' : ''}`} >

                          <a className="search-sugg-link"
                            onClick={() => {
                              searchOnSuggestion(suggestion, true, 'suggestion')
                            }}>
                            {/* <span className="flex"> <span className={`tags-ui1 ${suggestion.Index == IndexName.research ? 'tag-research' :  suggestion.Index == IndexName.practice ? 'tag-practice' : 'tag-webinar' }`}>
                             {IndexLabelSuggestion[suggestion.Index]} </span> </span> */}
                            <span className="keyword-name search-sugg-title"
                              dangerouslySetInnerHTML={{
                                __html: suggestion.heading
                              }} ></span>
                          </a>

                        </li>
                      })
                    }
                 </ul>
                </div>
              )}
            </div>
          </form>
          :
      
        showSearch ?
        <div className="main-search">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmitSearch(value);  
          }}
          ref={ref}
        >
          <div className="p-inputgroup search-sugestion-ui1" ref={containerRef}>
            <span className="search-field-1">
              <span className="search-textarea-box">
              <textarea
                  ref={inputRef}
                  value={value}
                  name="text" 
                  className="search-textarea-ui input" 
                  id="input" 
                  placeholder={placeholderText}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown}
                  onFocus={() => onFocusSearch(true)}
                  onBlur={onBlurSearch}
                  rows={1}
                  style={{
                    height: "36px",             
                    overflowX: "hidden",         
                    overflowY: "hidden",        
                    whiteSpace: "nowrap"      
                  }}
                />
                </span>
              {
                value?.length
                  ?
                  <span onClick={()=> onClickCrossSearch()} className="clear-text-cross">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4.9987 11.8781L7.9987 8.87812L10.9987 11.8781L11.8768 11L8.87682 8L11.8768 5L10.9987 4.12187L7.9987 7.12187L4.9987 4.12187L4.12057 5L7.12057 8L4.12057 11L4.9987 11.8781ZM8.00016 15.9167C6.90516 15.9167 5.87592 15.7089 4.91245 15.2933C3.94898 14.8778 3.11092 14.3138 2.39828 13.6015C1.68564 12.8891 1.12141 12.0514 0.705573 11.0883C0.289878 10.1253 0.0820312 9.09631 0.0820312 8.00145C0.0820312 6.90645 0.289809 5.87722 0.705365 4.91374C1.12092 3.95027 1.68488 3.11222 2.39724 2.39958C3.1096 1.68694 3.94731 1.1227 4.91037 0.70687C5.87342 0.291175 6.90238 0.0833282 7.99724 0.0833282C9.09224 0.0833282 10.1215 0.291106 11.0849 0.706661C12.0484 1.12222 12.8865 1.68618 13.5991 2.39854C14.3118 3.1109 14.876 3.94861 15.2918 4.91166C15.7075 5.87472 15.9154 6.90368 15.9154 7.99854C15.9154 9.09354 15.7076 10.1228 15.292 11.0862C14.8765 12.0497 14.3125 12.8878 13.6002 13.6004C12.8878 14.3131 12.0501 14.8773 11.087 15.2931C10.124 15.7088 9.09502 15.9167 8.00016 15.9167Z" fill="#969BAC" />
                    </svg>

                  </span>
                  : ''
              }

              <span className="advance_ui_1" onClick={() => { setAdvanceSearchVisible(true) }}>
                <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.56071 4.16855H20.4856C20.8313 4.16855 21.1244 3.87543 21.1244 3.52972C21.1244 3.184 20.8313 2.89088 20.4856 2.89088H7.56071C7.21499 2.89088 6.92188 3.184 6.92188 3.52972C6.92188 3.87543 7.21499 4.16855 7.56071 4.16855Z" fill="#969BAC" stroke="#969BAC" stroke-width="0.25" />
                  <path d="M1.51383 4.16855H3.52964C3.92117 4.16855 4.16848 3.86898 4.16848 3.52972C4.16848 3.184 3.87536 2.89088 3.52964 2.89088H1.51383C1.16812 2.89088 0.875 3.184 0.875 3.52972C0.875 3.87543 1.16812 4.16855 1.51383 4.16855Z" fill="#969BAC" stroke="#969BAC" stroke-width="0.25" />
                  <path d="M17.0881 9.03006H20.4873C20.833 9.03006 21.1261 8.73694 21.1261 8.39123C21.1261 8.04551 20.833 7.7524 20.4873 7.7524H17.0881C16.7423 7.7524 16.4492 8.04551 16.4492 8.39123C16.4492 8.73695 16.7423 9.03006 17.0881 9.03006Z" fill="#969BAC" stroke="#969BAC" stroke-width="0.25" />
                  <path d="M1.51383 9.03006H13.0553C13.4011 9.03006 13.6942 8.73694 13.6942 8.39123C13.6942 8.04551 13.4011 7.7524 13.0553 7.7524H1.51383C1.16812 7.7524 0.875 8.04551 0.875 8.39123C0.875 8.73694 1.16812 9.03006 1.51383 9.03006Z" fill="#969BAC" stroke="#969BAC" stroke-width="0.25" />
                  <path d="M7.56071 13.9315H20.4856C20.8313 13.9315 21.1244 13.6384 21.1244 13.2927C21.1244 12.947 20.8313 12.6539 20.4856 12.6539H7.56071C7.21499 12.6539 6.92188 12.947 6.92188 13.2927C6.92188 13.6384 7.21499 13.9315 7.56071 13.9315Z" fill="#969BAC" stroke="#969BAC" stroke-width="0.25" />
                  <path d="M1.51383 13.9311H3.52964C3.90925 13.9311 4.21357 13.6408 4.16843 13.2449C4.16403 12.9026 3.87274 12.6139 3.52964 12.6139H1.51383C1.16215 12.6139 0.875 12.9131 0.875 13.2923C0.875 13.638 1.16812 13.9311 1.51383 13.9311Z" fill="#969BAC" stroke="#969BAC" stroke-width="0.25" />
                  <path d="M2.89062 3.5296C2.89062 4.98203 4.09283 6.18424 5.54527 6.18424C7.0385 6.18424 8.19991 4.98076 8.19991 3.5296C8.19991 2.07716 6.9977 0.874954 5.54527 0.874954C4.09283 0.874954 2.89062 2.07716 2.89062 3.5296ZM4.16829 3.5296C4.16829 2.7686 4.78427 2.15262 5.54527 2.15262C6.30627 2.15262 6.92225 2.7686 6.92225 3.5296C6.92225 4.2906 6.30627 4.90658 5.54527 4.90658C4.78427 4.90658 4.16829 4.2906 4.16829 3.5296Z" fill="#969BAC" stroke="#969BAC" stroke-width="0.25" />
                  <path d="M12.418 8.39132C12.418 9.84376 13.6202 11.046 15.0726 11.046C16.5658 11.046 17.7273 9.84248 17.7273 8.39132C17.7273 6.93889 16.525 5.73668 15.0726 5.73668C13.6202 5.73668 12.418 6.93889 12.418 8.39132ZM13.6956 8.39132C13.6956 7.63032 14.3116 7.01435 15.0726 7.01435C15.8336 7.01435 16.4496 7.63032 16.4496 8.39132C16.4496 9.15233 15.8336 9.7683 15.0726 9.7683C14.3116 9.7683 13.6956 9.15233 13.6956 8.39132Z" fill="#969BAC" stroke="#969BAC" stroke-width="0.25" />
                  <path d="M2.89062 13.2923C2.89062 14.7448 4.09283 15.947 5.54527 15.947L8.07491 13.2923H8.19991C8.19991 13.2917 8.19991 13.2912 8.19991 13.2906C8.19893 11.8389 6.99711 10.6377 5.54527 10.6377C4.09411 10.6377 2.89062 11.7991 2.89062 13.2923ZM4.16829 13.2923C4.16829 12.5313 4.78427 11.9154 5.54527 11.9154C6.30627 11.9154 6.92225 12.5313 6.92225 13.2923C6.92225 14.0533 6.30627 14.6693 5.54527 14.6693C4.78427 14.6693 4.16829 14.0533 4.16829 13.2923Z" fill="#969BAC" stroke="#969BAC" stroke-width="0.25" />
                </svg>


              </span>
              <Button
                type="submit"
                icon="pi pi-search"
                className="p-button-warning search-mob-cta"
              />
            </span>
            {((frequentSearch.length > 0 || searchSuggestions.length > 0) && showSearchSuggestions) && (
                    <div className="search-sugestion active">
                <ul className="overflow-auto max-suggestion" id="SuggestID">
                  {frequentSearch?.map((search: string, index: number) => (
                    <li key={`FrequnetSearch${index}`} id={`li-${index}`} className={`filter-select-list filter-select-history link-flex-1 link-flex-between ${index === selectedSuggestion ? 'tw-bg-slate-100' : ''}`}>
                      <span onClick={() => {
                        searchOnSuggestion(search, true, 'history')
                      }} >  <i className="pi pi-history"></i><a
                        className="search-history-link cursor-pointer"> {search} </a>

                      </span>
                      <span onClick={() => {
                        deleteFrequentSearch(search)
                      }}>
                        <a className="s-history-cross cursor-pointer">
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99284 0.333654C3.32617 0.333654 0.326172 3.33366 0.326172 7.00032C0.326172 10.667 3.32617 13.667 6.99284 13.667C10.6595 13.667 13.6595 10.667 13.6595 7.00032C13.6595 3.33366 10.6595 0.333654 6.99284 0.333654ZM10.3417 9.39933L9.40834 10.3327L7.00833 7.93266L4.60833 10.3327L3.675 9.39933L6.075 6.99933L3.675 4.59932L4.60833 3.66599L7.00833 6.06599L9.40834 3.66599L10.3417 4.59932L7.94167 6.99933L10.3417 9.39933Z" fill="#111C42" fill-opacity="0.45" />
                          </svg>
                        </a></span>
                    </li>))}
                  {
                    value?.length ?
                      <li className="suggestion-search-r1 filter-select-list link-flex-1"> <span className="pi pi-search"></span> <span>  Search:  <strong> {value} </strong> </span> </li>
                      : ''
                  }
                  {showSearchSuggestionsLoading&&value?.length>2&&<div style={{display:'flex',justifyContent:'center'}}><i className="pi pi-spinner pi-spin" style={{ fontSize: '2rem' }}></i></div> }
                  {
                    !showSearchSuggestionsLoading&&searchSuggestions?.map((suggestion: any, index: number) => {
                    // searchSuggestions?.map((suggestion: any, index: number) => {
                      return <li key={`SearchSuggestion${index}`} id={`li-${index}`} className={`filter-select-list link-flex-1 ${index + frequentSearch.length === selectedSuggestion ? 'tw-bg-slate-100' : ''}`} >

                        <a className="search-sugg-link"
                          onClick={() => {
                            searchOnSuggestion(suggestion, true, 'suggestion')
                          }}>
                          <span className="keyword-name search-sugg-title"
                            dangerouslySetInnerHTML={{
                              __html: suggestion.heading
                            }} ></span>
                        </a>

                      </li>
                    })
                  }
                </ul>
                </div>
                  )}
                </div>
              </form>
            </div>
            : ''
      )}
      <CustomDialog dialogSize={"md-dialog"} dismissableMask={true} header={'Advance Filters'} component={
          <AdvanceSearchForm advanceSearchData={advanceSearchData} onClickSearch={onClickSearch} onClickReset={onClickReset} />
        }
          onDialogHide={() => setAdvanceSearchVisible(false)} visible={advanceSearchVisible} />
    </>
  );
};

export default SearchProducts;
